var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-progress-step-bar",
      class: _vm.theme ? "c-progress-step-bar--" + _vm.theme : "",
      attrs: { "aria-label": "Progress" }
    },
    [
      _c(
        "ol",
        { attrs: { role: "list" } },
        _vm._l(_vm.steps, function(step, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "c-progress-step-bar__item",
              class: _vm.stepState(index + 1)
            },
            [
              _c("div", { staticClass: "c-progress-step-bar__step" }, [
                _c("span", { staticClass: "c-progress-step-bar__step-label" }, [
                  _vm._v(_vm._s(step.label))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-progress-step-bar__percentage" }, [
                _c("div", {
                  staticClass: "c-progress-step-bar__percentage-inner",
                  style: step.progress ? "width : " + step.progress : null
                })
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffbf1e8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffbf1e8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/progress-step-bar/ProgressStepBar.vue
// module id = 674
// module chunks = 0